import React, { Component } from 'react'
import CommonGridHeader, { CommonPatientDetails } from '../../../Components/Common Components/CommonComponents'
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { getCachevalue, localGetItem } from '../../../Utility/Services/CacheProviderService'
import { Colors } from '../../../Styles/Colors'
import Loader from '../../../Components/Loader';
import { DataGrid } from '@mui/x-data-grid'
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker'
import './Reports.css'
import PrintPreviewPop from '../../../Components/Common Components/PrintPreviewPop'

export default class DocDoctorVisitReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      patientDetails: {},
      clinicId: '',
      appointmentId: '',
      patientId: '',
      doctorVisitReportData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      startDate: '',
      endDate: '',
      dateIndex: 0,
      selectedDoctor: "All",
      doctorId: null,
      isOPT: false,
      fromCounsellor: this.props.history?.location?.state?.fromCounsellor,
      SelectedItem: {},
      BillPreviewPop: false,
    }
  }

  componentDidMount() {
    let clinicId = getCachevalue('SelectedDoctorClinic')
    let appointmentId = this.props.fromOT ? JSON.parse(getCachevalue("OTpatientData")) : JSON.parse(getCachevalue('DoctorPatientData'))
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    this.setState({
      clinicId: clinicId ? clinicId : myUser?.clinic_id,
      appointmentId: appointmentId?.appointment_id,
      patientId: appointmentId?.patient_id ? appointmentId?.patient_id : this.props.history?.location?.state?.patientDetails?.patient_id,
      doctorId: appointmentId?.doctor_id,
      isOPT: UserData.service_type === "OPT" ? true : false,
      patientDetails: appointmentId
    }, () => {
      this.getPatientDetailData()
      this.getDoctorClinicListData()
      this.getDoctorVisitReportData()
    })
  }

  getPatientDetailData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientDetails: {...this.state.patientDetails, ...response?.data?.data}
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorClinicListData = () => {
    try {
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
      let isOpthometry = UserData?.module_name === "Optometry"
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_CLINIC_LIST_GET + `?clinic_id=${this.state.clinicId}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              doctorClinicList: response.data.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorVisitReportData = () => {
    try {
      let doctorId = this.state.selectedDoctor ? this.state.selectedDoctor == "All" ? "" : this.state.selectedDoctor?.doctor_id : ''
      this.setState({ loading: true })
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
      let ApiUrl = ""
      if (this.props.history?.location?.state?.fromCounsellor) {
        ApiUrl = Serviceurls.DOC_DOCTOR_VISIT_REPORT + `?patient_id=${this.state.patientId}&start_date=${this.state.startDate}&end_date=${this.state.endDate}&clinic_id=${UserData?.clinic_id}&doctor_id=${doctorId}`
      } else {
        ApiUrl = Serviceurls.DOC_DOCTOR_VISIT_REPORT + `?patient_id=${this.state.patientId}&start_date=${this.state.startDate}&end_date=${this.state.endDate}&clinic_id=&doctor_id=${doctorId}`
      }
      RestAPIService.getAll(ApiUrl) 
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              doctorVisitReportData: response?.data?.data,
              loading: false
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.data) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.data)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ loading: false })
      this.errorMessage(error.message)
    }
  }

  getDoctorVisitReportPrint = (item) => {
    let ServiceURL = Serviceurls.DOCTOR_NOTES_PRINT
    try {
      RestAPIService.getAllPrint(ServiceURL + `?appointment_id=${item?.appointment_id}&clinic_id=${this.state.clinicId}&doctor_id=${item?.doctor_id}&doctor_notes=all`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  filterDate = (From, To, Index) => {
    this.setState({
      startDate: From,
      endDate: To,
      dateIndex: Index
    })
  }

  onClearDoctorVisitReport = () => {
    try {
      this.setState({
        startDate: '',
        endDate: '',
        dateIndex: 0,
        selectedDoctor: "All"
      }, () => { this.getDoctorVisitReportData() })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderLeftSide = () => {
    try {
      this.state.doctorVisitReportData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        { field: 'visit_date', headerName: 'Visited Date', flex: 0.2 },
        { field: 'visit_time', headerName: 'Visited Time', flex: 0.15 },
        {
          field: 'branch_name', headerName: 'Branch Name', flex: 0.2,
          renderCell: (params) => {
            return (
              <Box emed_tid={`doc_visit_report_branch_cell_${params.row.sno}`}>
                {params?.row?.branch_name ? params?.row?.branch_name?.length > 20 ?
                  <Tooltip placement='top' title={params?.row?.branch_name} emed_tid={`doc_visit_report_branch_tooltip_${params.row.sno}`}><Typography emed_tid={`doc_visit_report_branch_truncated_${params.row.sno}`}>{params?.row?.branch_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
                  <Typography emed_tid={`doc_visit_report_branch_full_${params.row.sno}`}>{params?.row?.branch_name}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'doctor_name', headerName: 'Doctor Name', flex: 0.2,
          renderCell: (params) => {
            return (
              <Box emed_tid={`doc_visit_report_doctor_cell_${params.row.sno}`}>
                {params?.row?.doctor_name ? params?.row?.doctor_name?.length > 20 ?
                  <Tooltip placement='top' title={params?.row?.doctor_name} emed_tid={`doc_visit_report_doctor_tooltip_${params.row.sno}`}><Typography emed_tid={`doc_visit_report_doctor_truncated_${params.row.sno}`}>{params?.row?.doctor_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
                  <Typography emed_tid={`doc_visit_report_doctor_full_${params.row.sno}`}>{params?.row?.doctor_name}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'visit_note', headerName: 'Medical Report', flex: 0.25,
          renderCell: (params) => (
            <Box component={'div'} emed_tid={`doc_visit_report_medical_cell_${params.row.sno}`}>

              {params?.row?.visit_note === 'View' ?
                <Box emed_tid={`doc_visit_report_medical_view_${params.row.sno}`}>
                  <Button
                    className='Common_Btn_Min_Width'
                    sx={{ textTransform: 'capitalize' }}
                    onClick={() => {
                      if (localGetItem('dvr_print_config') === 'newtab') {
                        this.getDoctorVisitReportPrint(params?.row)
                      } else {
                        this.setState({ BillPreviewPop: true, SelectedItem: params?.row })
                      }
                    }}
                    emed_tid={`doc_visit_report_print_btn_${params.row.sno}`}
                  >{'Print'}</Button>
                  {params?.row?.reason_for_admission ? params?.row?.reason_for_admission?.length > 20 ?
                    <Tooltip placement='top' title={params?.row?.reason_for_admission} emed_tid={`doc_visit_report_reason_tooltip_${params.row.sno}`}><Typography emed_tid={`doc_visit_report_reason_truncated_${params.row.sno}`}>{params?.row?.reason_for_admission?.slice(0, 20) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.8vw'} emed_tid={`doc_visit_report_reason_full_${params.row.sno}`}>{params?.row?.reason_for_admission}</Typography> : null
                  }
                </Box>
                :
                <Box emed_tid={`doc_visit_report_medical_note_${params.row.sno}`}>
                  <Typography fontSize={params?.row?.is_ip_patient ? '0.9vw' : '0.9vw'} emed_tid={`doc_visit_report_visit_note_${params.row.sno}`}>{params?.row?.visit_note}</Typography>
                  {params?.row?.reason_for_admission ? params?.row?.reason_for_admission?.length > 20 ?
                    <Tooltip placement='top' title={params?.row?.reason_for_admission} emed_tid={`doc_visit_report_reason_tooltip_${params.row.sno}`}><Typography emed_tid={`doc_visit_report_reason_truncated_${params.row.sno}`}>{params?.row?.reason_for_admission?.slice(0, 20) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.8vw'} emed_tid={`doc_visit_report_reason_full_${params.row.sno}`}>{params?.row?.reason_for_admission}</Typography> : null
                  }
                </Box>
              }
            </Box>
          )
        },
      ]
      return (
        <DataGrid
          rows={this.state.doctorVisitReportData}
          columns={columns}
          getRowId={(row) => row['sno']}
          page={this.state.page}
          pageSize={this.state.pageSize}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          sx={{
            backgroundColor: Colors.white,
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "inherit"
            }
          }}
          components={{
            Toolbar: CommonGridHeader.CommonToolBar,
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata' emed_tid="doc_visit_report_no_records">
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          onPageChange={(newPage) => { this.setState({ page: newPage }) }}
          onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
          getRowClassName={(params) => params.row?.is_ip_patient ? 'eMedhub_highlight_column' : null}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          headerHeight={40}
          disableSelectionOnClick
          loading={this.state.loading}
          emed_tid="doc_visit_report_datagrid"
        />
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  ClosePopUp() {
    this.setState({
        BillPreviewPop: false,
        SelectedItem: {}
    })
}

  renderRightSide = () => {
    try {
      return (
        <Box component={'div'} emed_tid="doc_visit_report_filter_container">
          <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'} emed_tid="doc_visit_report_filter_title">
            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} emed_tid="doc_visit_report_filter_title_text">Doctor Visit Report</Typography>
          </Box>
          <Box component={'div'} height={'23vw'} sx={{ background: Colors.white }} p={'1vw'} emed_tid="doc_visit_report_filter_content">
            <Box component={'div'} width={'21vw'} emed_tid="doc_visit_report_date_picker_container">
              <CommonDatePicker
                FromDate={this.state.startDate}
                ToDate={this.state.endDate}
                DateIndex={this.state.dateIndex}
                SelectedDates={this.filterDate.bind(this)}
                emed_tid="doc_visit_report_date_picker"
              />
            </Box>
            <Box mt={'0.5vw'} emed_tid="doc_visit_report_doctor_select_container">
              <FormControl size='small' className='eMed_small_textFields' emed_tid="doc_visit_report_doctor_form">
                <InputLabel emed_tid="doc_visit_report_doctor_label">{"Select Doctor"}</InputLabel>
                <Select
                  value={this.state.selectedDoctor ? this.state.selectedDoctor : ""}
                  label={"Select Doctor"}
                  onChange={(e) => { this.setState({ selectedDoctor: e.target.value }) }}
                  MenuProps={{
                    style: { maxHeight: 350 }
                  }}
                  emed_tid="doc_visit_report_doctor_select"
                >
                  <MenuItem value={"All"} emed_tid="doc_visit_report_doctor_option_all">{"All"}</MenuItem>
                  {
                    this.state.doctorClinicList?.length > 0 ?
                      this.state.doctorClinicList.map((list, index) => (
                        <MenuItem key={index} value={list} emed_tid={`doc_visit_report_doctor_option_${index}`}>{`${(list?.title ? list?.title : "")} ${list?.first_name} ${(list?.initial ? list?.initial : "")}`}</MenuItem>
                      )) : null
                  }
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'} emed_tid="doc_visit_report_filter_buttons">
            <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
              variant='outlined'
              onClick={() => { this.onClearDoctorVisitReport() }}
              emed_tid="doc_visit_report_clear_btn"
            >Clear</Button>
            <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
              variant='contained'
              onClick={() => { this.getDoctorVisitReportData() }}
              emed_tid="doc_visit_report_search_btn"
            >Search</Button>
          </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  render() {
    let ServiceURL = Serviceurls.DOCTOR_NOTES_PRINT;
    let Url =  ServiceURL + `?appointment_id=${this.state.SelectedItem?.appointment_id}&clinic_id=${this.state.clinicId}&doctor_id=${this.state.SelectedItem?.doctor_id}&doctor_notes=all`
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={this.state.fromCounsellor ? '79vh' : '74vh'} p={'0.5vw'} emed_tid="doc_visit_report_container">
        <Box component={'div'} display={'flex'} emed_tid="doc_visit_report_header">
          <Box component={'div'} className='doc_header_card' mr={'0.5vw'} emed_tid="doc_visit_report_patient_card">
            <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} emed_tid="doc_visit_report_patient_details" />
          </Box>
        </Box>
        <Box component={'div'} display={'flex'} mt={'0.5vw'} height={this.state.fromCounsellor ? '65.5vh' : '61.5vh'} emed_tid="doc_visit_report_content">
          <Box component={'div'} flex={0.65} overflow={'scroll'} emed_tid="doc_visit_report_left_side">
            {this.renderLeftSide()}
          </Box>
          <Box component={'div'} flex={0.35} border={'1px solid lightgray'} emed_tid="doc_visit_report_right_side">
            {this.renderRightSide()}
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="doc_visit_report_error_toast"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="doc_visit_report_success_toast"
          />
          : null}
        {
          this.state.BillPreviewPop ?
            <PrintPreviewPop
              PRINT_URL={Url}
              Title={"Doctor Visit Report"}
              BillData={this.state.SelectedItem}
              ClosePopUp={this.ClosePopUp.bind(this)}
              PrintButton={false}
              emed_tid="doc_visit_report_print_preview" /> : null
        }
        <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}
